import { CSSObject } from "@emotion/react";
import {
  typographyStyles,
  constants,
  cssVariableStyles,
} from "@newsela/angelou";
const { heading4Obj, fontFamily } = typographyStyles;

const { generateIconColorCss } = cssVariableStyles;

const {
  colors: { ui },
} = constants;

const whiteIcon = generateIconColorCss({ primaryColor: ui.white[500] });

const backgroundColorVariants = [
  ui.purple[700],
  ui.teal[700],
  ui.pink[700],
  ui.yellow[700],
  ui.green[700],
];

export const cardCss = (cardIndex: number) => {
  const backgroundColorIndex = cardIndex % backgroundColorVariants.length;

  return {
    borderRadius: "16px",
    backgroundColor: backgroundColorVariants[backgroundColorIndex],
    "a:first-of-type:after": {
      borderRadius: "16px",
    },
  };
};

export const cardContentCss: CSSObject[] = [
  {
    padding: "16px",
    display: "flex",
    gap: "8px",
  },
  heading4Obj,
  fontFamily.noto,
];

export const cardIconCss: CSSObject = {
  ...whiteIcon,
  minWidth: "24px",
  minHeight: "24px",
};

export const cardTitleCss: CSSObject = {
  alignItems: "center",
  color: ui.white[700],
  display: "flex",
  fontSize: "18px",
  fontWeight: 700,
};
